import React from "react";
import { MoreHorizontal } from "lucide-react";
import DeleteMenu from "./DeleteMenu";
import { getProgressColor } from "./utils";

export default function HistoryItem({
  item,
  isLoading,
  onClick,
  onMenuClick,
  onDelete,
  formatTimestamp,
  isMenuOpen,
  isDark,
  index,
}) {
  const humanScore = Math.round((item.human_score || 0) * 100);
  const preview = item.humanized_text ? item.humanized_text : "Untitled text";

  return (
    <div
      className="relative"
      style={{
        animation: `fadeInSlideLeft 300ms ease-out ${(index || 0) * 50}ms both`,
        zIndex: isMenuOpen ? 100 : "auto",
      }}
    >
      <div
        className={`flex flex-row items-center px-16 py-12 gap-20 transition-all duration-200 ${
          isDark
            ? "border-b border-white-alpha-05 hover:bg-white-alpha-05 active:bg-white-alpha-10"
            : "border-b border-[#0D0D0D]/5 hover:bg-[#0D0D0D]/2 active:bg-[#0D0D0D]/5"
        }`}
      >
        <button
          onClick={onClick}
          disabled={isLoading}
          className="flex-1 min-w-0 text-left disabled:opacity-50 disabled:cursor-not-allowed transition-opacity duration-200"
        >
          <div className="flex flex-col gap-8">
            <div
              className={`font-regular line-clamp-1 text-[14px] leading-[1.43em] tracking-[-2%] ${
                isDark ? "text-white" : "text-black"
              }`}
            >
              {preview}
            </div>
            <div className="flex items-center gap-14">
              {/* Human Badge */}
              <div
                className="flex items-center gap-2 px-5 py-2 rounded-full"
                style={{
                  background: getProgressColor(humanScore, false, isDark),
                }}
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_13254_8797)">
                    <path
                      d="M6.5 7.031V11H2C1.99995 10.4325 2.12067 9.87142 2.35413 9.35413C2.5876 8.83684 2.92848 8.37516 3.35411 7.99975C3.77974 7.62434 4.28039 7.34381 4.82279 7.17678C5.36519 7.00975 5.93692 6.96006 6.5 7.031ZM6 6.5C4.3425 6.5 3 5.1575 3 3.5C3 1.8425 4.3425 0.5 6 0.5C7.6575 0.5 9 1.8425 9 3.5C9 5.1575 7.6575 6.5 6 6.5ZM8.8965 9.957L10.664 8.1895L11.3715 8.8965L8.8965 11.3715L7.1285 9.6035L7.836 8.8965L8.896 9.957H8.8965Z"
                      fill={getProgressColor(humanScore, true, isDark)}
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_13254_8797">
                      <rect width="12" height="12" fill="currentColor" />
                    </clipPath>
                  </defs>
                </svg>
                <span
                  className={`font-medium text-[12px] leading-[1.33em] tracking-[-2%]`}
                  style={{ color: getProgressColor(humanScore, true, isDark) }}
                >
                  {humanScore}% Human
                </span>
              </div>
              {/* Timestamp */}
              <span
                className={`font-medium text-[12px] leading-[1.33em] tracking-[-2%] ${
                  isDark ? "text-[#CDCDCD]" : "text-[#5D5D5D]"
                }`}
              >
                {formatTimestamp(item.created_at)}
              </span>
            </div>
          </div>
        </button>

        <button
          onClick={onMenuClick}
          className={`flex-shrink-0 p-4 rounded transition-all duration-200 ${
            isDark
              ? "hover:bg-white-alpha-05 active:bg-white-alpha-10"
              : "hover:bg-black-alpha-05 active:bg-black-alpha-10"
          }`}
        >
          <MoreHorizontal
            className={`w-[15px] h-[15px] transition-transform duration-200`}
            style={{ color: isDark ? "#FFFFFF" : "#0D0D0D" }}
            strokeWidth={2}
          />
        </button>
      </div>

      {/* Context Menu */}
      {isMenuOpen && (
        <div
          className="absolute right-0 top-2/3 mt-1"
          style={{
            animation: "fadeInZoom 200ms ease-out both",
            transformOrigin: "top right",
            zIndex: 1000,
          }}
        >
          <DeleteMenu onDelete={onDelete} isDark={isDark} />
        </div>
      )}
    </div>
  );
}
